import React, { useState, useEffect } from "react";
import {
  getaxiosadminRequestWithToken,
  putaxiosadminRequestWithToken,
} from "../../../api/api";
import { handleSession } from "../../../api/apiSessionHandle";
import { useNavigate } from "react-router-dom";
import { PaginationControls } from "../../../components/pagination";
import CommonSpinner from "../../../services/commonSpinner";
import { FaEdit } from "react-icons/fa";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import { showToast } from './../../../services/toastifyservices';



const ManageVisit = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [formLoading ,setFormLoading] = useState(false)
  const [selectedName, setSelectedName] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedPriority, setSelectedPriority] = useState("");
  const [visitData, setVisitData] = useState([])
  const [selectedVisit, setSelectedVisit] = useState({})
  const [editedStatus, setEditedStatus] = useState("");
  const [editedPriority, setEditedPriority] = useState("");
  const [isOpen, setIsOpen] = useState(false);


  const Statuses = [
    { id: "active", name: "Active" },
    { id: "inactive", name: "Inactive" },
  ];
  const Priority = [
    { id: "high", name: "High" },
    { id: "low", name: "Low" },
  ];

  //! Pagination state
  const [currentPage, setCurrentPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState();
  const [totalPages, setTotalPages] = useState();


  useEffect(() => {
    GetVisitData("active", selectedPriority, selectedName);
  }, []);

  const GetVisitData = async (status, priority, input, page) => {
    try {
      let payload = {
        status: status,
        priority: priority,
        name: input,
        page: page,
      };
      setLoading(true);
      const response = await getaxiosadminRequestWithToken(
        `common_api/visit_reasons`,
        payload
      );
      if (response.success) {
        var responsedata = response.data;

        setVisitData(responsedata.visit_reasons.data);
        setRowsPerPage(responsedata.visit_reasons.per_page);
        setCurrentPage(responsedata.visit_reasons.current_page);
        setTotalPages(Math.ceil(responsedata.visit_reasons.total / responsedata.visit_reasons.per_page));
      }
    } catch (error) {
      setLoading(false);
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const handleError = (error) => {
    showToast(
      "error",
      error.response?.data?.message || "Something went wrong."
    );
    handleSession(error.response?.data, navigate);
  };
  const handleSearch = () => {
    GetVisitData(selectedStatus, selectedPriority, selectedName);
  };


  const handleEdit = (cause) => {
    setSelectedVisit(cause);
    setIsOpen(true);
    setEditedStatus(cause.status);
    setEditedPriority(cause.priority);
  };

  const handleUpdate = async () => {
    if (
      editedStatus === selectedVisit.status &&
      editedPriority === selectedVisit.priority
    ) {
      setIsOpen(false);
      return;
    }
    setFormLoading(true)
    const Payload = {
      id: selectedVisit.id,
      status: editedStatus,
      priority: editedPriority,
    };
    try {
      const response = await putaxiosadminRequestWithToken(
        "common_api/update_visit_reason",
        Payload
      );
      if (response.success) {
        showToast("success", response.message);
        setIsOpen(false);
        GetVisitData(selectedStatus, selectedPriority, selectedName);
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
    }
    finally{
      setFormLoading(false)
    }
  };


  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      GetVisitData(selectedStatus, selectedPriority, selectedName, page);
    }
  };
  //! handle rows per page
  const handleRowsPerPageChange = (e) => {
    const newLimit = parseInt(e.target.value, 10);
    setRowsPerPage(newLimit);
    GetVisitData(currentPage, newLimit);
  };

  return (
    <div className="mt-3 p-2 md:p-10 bg-gray-200">
      <div className="card">
        <span className="text-start font-bold ml-4 p-2 headingtext">
          Manage Visit
        </span>
      </div>
      <div className="card p-3">
        <div className="row d-flex align-items-end justify-content-between">
          <div className="col-md-3">
            <label className="form-label font-bold">Name</label>
            <input
              type="text"
              className="form-control"
              value={selectedName}
              onKeyDown={(e) =>
                e.key === "Enter" &&
                GetVisitData(selectedStatus, selectedPriority, selectedName)
              }
              onChange={(e) => setSelectedName(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label font-bold">Status</label>
            <select
              className="form-select"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label font-bold">Priority</label>
            <select
              className="form-select"
              value={selectedPriority}
              onChange={(e) => setSelectedPriority(e.target.value)}
            >
              <option value="">Select Priority</option>
              <option value="high">High</option>
              <option value="low">Low</option>
            </select>
          </div>
          {/* Buttons section - Using d-flex to keep them aligned */}
          <div className="col-md-3 d-flex justify-content-between">
            <button
              className="btn btn-primary fw-bold btncolor"
              onClick={handleSearch}
            >
              SEARCH
            </button>
          </div>
        </div>
      </div>
      {/* section for display visitdata */}

      <div className="card">
        <div className="table-container">
          <table className="table table-striped table-hover">
            <thead className="table-header table-primary">
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Priority</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {visitData.map((data) => (
                <tr key={data.id}>
                  <td>{data.name}</td>
                  <td>
                    {" "}
                    {data.status.charAt(0).toUpperCase() + data.status.slice(1)}
                  </td>
                  <td>
                    {" "}
                    {data.priority.charAt(0).toUpperCase() +
                      data.priority.slice(1)}
                  </td>

                  <td>
                    <button
                      onClick={() => handleEdit(data)}
                      className="btn btn-sm btn-primary"
                    >
                      <FaEdit style={{ cursor: "pointer" }} />{" "}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* section for modal */}

      <Modal show={isOpen} onHide={() => setIsOpen(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Update Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-3 border rounded shadow-sm bg-light flex-grow-1">
            <div className="row mb-3">
              <div className="col-md-6">
                <h6 className="fw-bold">Status:</h6>
                <Form.Select
                  value={editedStatus}
                  onChange={(e) => setEditedStatus(e.target.value)}
                >
                  {Statuses.map((status) => (
                    <option key={status.id} value={status.id}>
                      {status.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
              <div className="col-md-6">
                <h6 className="fw-bold">Priority:</h6>
                <Form.Select
                  value={editedPriority}
                  onChange={(e) => setEditedPriority(e.target.value)}
                >
                  {Priority.map((priority) => (
                    <option key={priority.id} value={priority.id}>
                      {priority.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setIsOpen(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleUpdate}>
            {formLoading ?  <><Spinner animation="border" size="sm" /> Updating.. </>: "Update"}
          </Button>
        </Modal.Footer>
      </Modal>

      {loading ? null : (
        <div className="pagination-controls">
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            onLimitPerPage={handleRowsPerPageChange}
          />
        </div>
      )}
      {loading && <CommonSpinner />}
    </div>
  );
};

export default ManageVisit;
